// Кризис-менеджер (deus_krizis_menedzher, rare) — order.
// При размещении (момент вскрытия в Ф3 после Действий, перед авто-атаками):
// Герой владельца +0/0/3 (HP, может превышать максимум, постоянно на матч).
// Изменено в А.4.4.4 (xlsx-правка): было +0/2/0, стало +0/0/3.

export const CARD_ID = 'deus_krizis_menedzher';

export function krizisMenedzherOrder(state, ownerIdx, card) {
  const p = state.players[ownerIdx];
  if (!p || !card.isAlive()) return;
  // +3 HP Герою, может превышать max.
  p.hero.current.hp += 3;
  state.log.add(`📈 Кризис-менеджер [${p.name}]: Герой +0/0/3 (HP=${p.hero.hp})`);
}
